import { FormControl, FormField, FormItem, FormMessage } from "@patient-watch/ui/form";
import { useFormContext } from "react-hook-form";
import RatingOptions from "./RatingOptions";
import { ChoiceCard } from "./components/ChoiceCard";

import type { InputT } from "@patient-watch/types";

interface Props {
    input: InputT;
    name: string;
    label: string;
}

const Rating = ({ input, name, label }: Props) => {
    const { control } = useFormContext();

    return (
        <FormField
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <FormItem>
                    <ChoiceCard
                        caption={input.input_caption}
                        label={label}
                        required={!input.is_optional}
                        description={input.input_description}
                        invalid={fieldState.invalid}
                    >
                        <FormControl>
                            <RatingOptions
                                options={input.scale_options || []}
                                orientation={input.orientation || "horizontal"}
                                value={field.value}
                                onChange={field.onChange}
                                name={name}
                            />
                        </FormControl>
                        <FormMessage />
                    </ChoiceCard>
                </FormItem>
            )}
        />
    );
};

export default Rating;
